import { useEffect, useState } from 'react'; // , useContext
// import { Link } from 'react-router-dom';
// import DisplayRegistrations from '../../components/DisplayRegistrations';
import axiosInstance from "../../helpers/Axios";
import type { IContact } from '../../interfaces/IContact';

const defaultList: ICourseObj[] = [];

interface IDay {
  name: string;
}

interface ICourse {
  shortName: string;
  name: string;
  day: IDay;
  isVisible: boolean;
  startTime: string;
  endTime: string;
}

interface ICourseObj {
  course: ICourse;
  subscribes: IContact[];
}


const Stages = () => {

  const [list, setList] = useState(defaultList);
  const [visible, setVisible] = useState(true);
  const loading = list === defaultList && visible;

  useEffect(() => {
    if (loading)
      axiosInstance.get("/course?withStudents=true")
        .then(response => {
          //console.log('response', response);

          setList(response.data);//.map((courseObj : ICourseObj) => courseObj.course))
          // console.log("réponse",response.data);
          // setUserProfile(response.data);
          // setLocation(response.data.location);
        })
        .catch((err) => {
          const error = err.response === undefined ?
            'Server in not reachable'
            : err.response.data;
          console.log('error', error);
          setVisible(false);
        });
  }
  );

  // console.log("list", list);

  return (
    <div id="courses">
      <div id="title">
        <h1>Inscriptions par cours</h1>
      </div>
      <div id="content">
        
        {/* {
        loading ?
        <p>Chargement en cours...</p>
        :
        visible ?
          <DisplayRegistrations stages={undefined} courses={list} title="Choisir votre cours"/>
          :
            <div>
              <p>Le système d'inscription est actuellement en panne.</p>
            </div>
            } */}
        <h2>En construction...</h2>
      </div>
    </div >
  )
};

export default Stages;
